<template>
  <div class="empty-content-container d-flex flex-column gap-3 align-items-center flex-grow-1 justify-content-center">
    <div class="img-container">
      <img :src="noContentImage" alt="No content Image">
    </div>
    <div class="text-content text-center">
      No short description has been provided for this plan.
    </div>
  </div>
</template>

<script>
export default {
  name: "ShortDescriptionPlanInfo",
  data () {
    return {
      noContentImage: require('../assets/images/nocontent.svg')
    }
  }
}
</script>

<style scoped>
.empty-content-container .img-container img{
  width: 200px;
  max-width: 200px !important;
  max-height: 100% !important;
}
.empty-content-container  .text-content{
  font-size: 15px;
}
.plan-default-logo img{
  max-width: 170px;
  max-height: 70px;
  margin-bottom: 14px;
  display: flex;
  align-items: flex-start;
}

</style>